import DOMPurify from 'dompurify';

/**
 * Security review HIGH-001: sanitizes an HTML string before it is injected into
 * the DOM through a `dangerouslySetInnerHTML` / `innerHTML` sink.
 *
 * Uses DOMPurify with its safe defaults: `<script>`, event handler attributes
 * (`onerror`, `onclick`, ...) and dangerous URL schemes (`javascript:`, ...)
 * are removed, while the rich formatting the portals rely on (tables, lists,
 * links, inline styles, mentions) is preserved.
 *
 * Accepts `null`/`undefined` and always returns a string, so it can wrap any
 * existing sink expression without extra guards.
 */
export const sanitizeHtml = (dirty: unknown): string => {
  if (dirty === null || dirty === undefined) {
    return '';
  }
  return DOMPurify.sanitize(String(dirty));
};
